<template>
  <v-container class="pa-3">
    <form-user
      :items="recipient"
      displayMode
      class="pa-0"
    />

    <v-divider class="my-2" />

    <form-address
      :items="recipient.address"
      displayMode
      class="pa-0"
    />

  </v-container>
</template>

<script>
  import FormUser from '@/components/ui/forms/FormUser'
  import FormAddress from '@/components/ui/forms/FormAddress'
  import { mapGetters } from 'vuex'

  export default {
    components: { FormUser, FormAddress },
    computed: {
      ...mapGetters({
        recipient: 'recipients/record'
      })
    },
    methods: {
      updateInfo () {
        this.$store.dispatch('recipients/get', this.$route.params.recipientId)
      }
    },
    watch: {
      '$route': 'updateInfo'
    },
    beforeMount () {
      this.updateInfo()
    },
    beforeDestroy () {
      this.$store.dispatch('recipients/unset')
    }
  }
</script>


